import GameSignals from '@/signals/GameSignals'
import { BaseState } from '@/stateMachine/BaseState'
import { GameStatesEnum } from '@/states/GameStatesEnum'
import Facade from '@/Facade'
import { SharedPopupManager } from '@dragonframework/modules'
import { isBuyBonusHidden } from '@/managers/ui/BuyBonusManager'

export class IdleState extends BaseState {
    public begin() {
        if (Facade.isTurboSpin && this._model.spinState.isWinSkipped) {
            this.end()
        }
        GameSignals.spinButtonClicked.connect(this.end)
        GameSignals.changeBet.connect(this._onChangedBet)
        GameSignals.buyBonusClicked.connect(this._onBuyBonusClicked)
        ;(GameSignals as any).gambleOfferAvailabilityChanged?.connect(this._onGambleOfferAvailabilityChanged)
        // Ensure Spin is interactive after FS/H&W exit (StopRound does not always unlock).
        GameSignals.unLockGamePanel.emit()
        GameSignals.idle.emit()

        if (this._model.canAutoStartPromoSpin()) {
            window.setTimeout(() => {
                // An offer still on screen has not been answered yet, so nothing may spin for it.
                if (
                    Facade.currentState === GameStatesEnum.IDLE_STATE &&
                    !SharedPopupManager.isPromoOfferPendingConfirmation &&
                    this._model.canAutoStartPromoSpin()
                ) {
                    this._model.markPromoAutoSpinStarted()
                    GameSignals.spinButtonClicked.emit()
                }
            }, 100)
        }
    }

    private _onBuyBonusClicked = (_bonusBuyId: number) => {
        if (isBuyBonusHidden()) {
            return
        }

        const fixedCoinsBet = this._model.fixedCoinsBet
        const fallbackMultiplier = 80
        const price = fixedCoinsBet * fallbackMultiplier

        this._model.bonusBuyBet = this._model.currentBet * (price / fixedCoinsBet)
        this._model.isBuyBonusPending = true
        this._model.buyBonusPickPosition = Math.max(0, _bonusBuyId - 1)
        this.end()
    }

    public end = () => {
        if (Facade.currentState !== GameStatesEnum.IDLE_STATE) {
            return
        }

        // Confirmed Buy Bonus must start the purchase spin even while overlay flags settle.
        if (!this._model.isBuyBonusPending) {
            // Space/Spin must not start a normal round while Buy Bonus (or similar) is up.
            if (Facade.isPopupBlockingInput || Boolean((Facade as any).isBuyBonusPopupOpen)) {
                return
            }
        }

        this._stateMachine.setState(GameStatesEnum.START_ROUND_STATE)
    }

    public cleanUp() {
        GameSignals.spinButtonClicked.disconnect(this.end)
        GameSignals.changeBet.disconnect(this._onChangedBet)
        GameSignals.buyBonusClicked.disconnect(this._onBuyBonusClicked)
        ;(GameSignals as any).gambleOfferAvailabilityChanged?.disconnect(this._onGambleOfferAvailabilityChanged)
    }

    private _onChangedBet = (bet: number) => {
        this._model.currentBet = bet
    }

    private _onGambleOfferAvailabilityChanged = (isAvailable: boolean) => {
        if (isAvailable) {
            ;(GameSignals as any).requestGambleCollect?.emit()
        }
    }
}
